import moment from 'moment';
import { i18n } from '@ecster/i18n';

const { EcsterConfig: conf } = window;

// YYYY-MM-DD
export const formatDate = date => {
    moment.locale('sv-SE');
    return moment(date).format('YYYY-MM-DD');
};

// 4 jan
export const formatDateShort = date => {
    const theDate = new Date(date);
    const dot = conf.locale === 'fi-FI' ? '.' : '';
    const key = `general.months.short.${theDate.getMonth()}`;
    return `${theDate.getDate()}${dot} ${i18n(key)}`;
};

// 4 jan 2020
export const formatDateShortWithYear = date => {
    const theDate = new Date(date);
    const dot = conf.locale === 'fi-FI' ? '.' : '';
    const key = `general.months.short.${theDate.getMonth()}`;
    return `${theDate.getDate()}${dot} ${i18n(key)} ${theDate.getFullYear()}`;
};

// 10 februari
export const formatDateLong = date => {
    const theDate = new Date(date);
    const key = `general.months.long.${theDate.getMonth()}`;
    return `${theDate.getDate()} ${i18n(key)}`;
};

// 10 februari 2020
export const formatDateLongWithYear = date => {
    const theDate = new Date(date);
    const key = `general.months.long.${theDate.getMonth()}`;
    return `${theDate.getDate()} ${i18n(key)} ${theDate.getFullYear()}`;
};

// januari
export const formatDateMonth = date => {
    const theDate = new Date(date);
    return i18n(`general.months.long.${theDate.getMonth()}`);
};

// apr
export const formatDateMonthShort = date => {
    const theDate = new Date(date);
    return i18n(`general.months.short.${theDate.getMonth()}`);
};
